// packages import
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import * as moment from 'moment';
import {PrimaryButton, FancyButton} from '../../../widgets';

// import styles
import './RedeemCoupon.css';
import {PlainDialog} from '../../../widgets';
import {uiActions} from '../../../chrome';

import ProfileCard, {PresentationProfileCard} from '../../../profile/ProfileCard';
import {getProviderUniqueName} from '../../community.selectors';

class RedeemCoupon extends Component {
	componentDidMount() {
		this.unlisten = this.props.history.listen(location => {
			this.props.onCancel();
		});
	}

	componentWillUnmount() {
		this.unlisten();
	}

	/**
	 * Function to redirect to current users wallet
	 * @param {*} e
	 */
	goToWallet = e => {
		const walletLink = `/profile/coupons/${getProviderUniqueName(this.props)}`;
		this.props.history.push(walletLink);
	};

	render() {
		const {onCancel, redeemedCoupon} = this.props;

		return (
			<PlainDialog onCancel={onCancel} className="redeemCoupon">
				<div>
					<div className="title">
						<h1>Congratulations</h1>
						<span>You have now successfully redeemed the coupon</span>
					</div>
					<div className="redeemptionDetails">
						<div className="centerBlock">
							<div className="wave-top">
								<div className="couponDetails">
									<div className="couponCode">
										<fieldset>
											<legend>Coupon Code</legend>
											<span>{redeemedCoupon.coupon.code}</span>
										</fieldset>
									</div>
									<div className="couponDescription">
										<p>{redeemedCoupon.coupon.description}</p>
										<span>
											Valid Till:{' '}
											{moment(redeemedCoupon.coupon.expiryDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
										</span>
									</div>
								</div>
							</div>
							<div className="couponProvider">
								<div className="providerInfoSeperator">
									<span>Provided By</span>
									<hr />
								</div>
								<ProfileCard provider={redeemedCoupon.coupon.created_by} />
							</div>
							<div className="redeemAction">
								<div className="goToProvider">
									<PrimaryButton icon="sdfsdf" onClick={this.goToWallet}>
										Go To My Wallet
									</PrimaryButton>
								</div>
								<div className="cancelBtn">
									<PrimaryButton icon="sdfsdf" onClick={onCancel}>
										Cancel
									</PrimaryButton>
								</div>
							</div>
						</div>
					</div>
				</div>
			</PlainDialog>
		);
	}
}

const mapStateToProps = state => {
	return {
		session: state.session,
		redeemedCoupon: state.coupon.redeemed
	};
};

const mapDispatchToProps = dispatch => {
	return {
		onCancel: () => {
			dispatch(uiActions.uiModal(null));
		}
	};
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(RedeemCoupon)
);



// WEBPACK FOOTER //
// ./src/community/coupons/redeem-coupon/RedeemCoupon.js